import { createActionTypeModel } from "../../../../store/global/action-model";

export const GENERAL_DATA = createActionTypeModel('GENERAL_DATA');
export const UPDATE_EXCHANGE_RATES = 'UPDATE_EXCHANGE_RATES';

export const Currencies = createActionTypeModel('Currencies');
export const Territories = createActionTypeModel('Territories');

